/* unplugin-vue-components disabled */import { render } from "./ExamQuiz.vue?vue&type=template&id=4b6130ff&scoped=true&ts=true"
import script from "./ExamQuiz.vue?vue&type=script&lang=ts"
export * from "./ExamQuiz.vue?vue&type=script&lang=ts"

import "./ExamQuiz.vue?vue&type=style&index=0&id=4b6130ff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6130ff"]])

export default __exports__